export const LIFECYCLE_STAGE_UPDATE_LIST_TEMPLATE = {
  op: 'ui',
  name: 'Box',
  sx: { px: 2, py: 1, width: '100%' },
  children: [
    {
      op: 'ui',
      name: 'BoldMatchedText',
      text: { op: 'context', path: 'account.display' },
      query: { op: 'context', path: 'query' },
      variant: 'body1',
    },
  ],
};
